export default "__VITE_ASSET__BHROputy__"